export default __webpack_public_path__ + "static/media/discover.4345e7d1.png";